import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Score' })({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 8,
        padding: '4px 8px',
        borderRadius: 96,
        fontSize: 14,
        fontWeight: 600,
        lineHeight: '16px',
        whiteSpace: 'nowrap'
    },
    label: {
        color: '#232323',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px'
    },
    _high: {
        color: '#F5726A',
        background: '#FFEBED'
    },
    _medium: {
        color: '#EB8F01',
        background: '#FCF2DE'
    },
    _low: {
        color: '#05A569',
        background: '#E5F6ED'
    },
    _unknown: {
        color: '#8E8E8E',
        background: '#ECECEC'
    }
});
